import { GET_CARD_SUMMARY, GET_CARD_SUMMARY_SUCCESS, GET_CARD_SUMMARY_ERROR, GET_CARD_SUMMARY_EMPTY } from '../../../actions';

const initialState = {
  data: null,
  loading: false,
  error: null,
  // one dispatch fans out into one call per card, and several dispatches can overlap (tab counts
  // + the WARNINGS/HIGH ALERTS tiles). Counting the calls still in flight keeps `loading` honest:
  // a single success no longer flips it off while siblings are pending, and a dispatch carrying no
  // cards no longer leaves it stuck on forever.
  pendingCount: 0,
};

const GetCardSummary = (state = initialState, action) => {
  switch (action.type) {
    case GET_CARD_SUMMARY: {
      const pendingCount = state.pendingCount + (action?.payload?.cards?.length ?? 0);

      return {
        ...state,
        pendingCount,
        loading: pendingCount > 0,
      };
    }

    case GET_CARD_SUMMARY_SUCCESS: {
      const pendingCount = Math.max(0, state.pendingCount - 1);

      return {
        ...state,
        pendingCount,
        loading: pendingCount > 0,
        data: {
          ...state?.data,
          [action.meta.cardName]: action.payload,
        },
      };
    }

    case GET_CARD_SUMMARY_ERROR: {
      const pendingCount = Math.max(0, state.pendingCount - 1);

      return {
        ...state,
        pendingCount,
        loading: pendingCount > 0,
        error: {
          ...state.error,
          [action.meta.cardName]: action.payload,
        },
      };
    }

    case GET_CARD_SUMMARY_EMPTY:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default GetCardSummary;
